const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2
})

const currencyFormat = (num) =>
  num?.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');

export const fiatFormat = (num) => {
  if(num > 0)
    return formatter.format(num);
  else
    return num;
}

export const toFiatValue = (sats_amount, USD_rate) =>
  sats_amount * USD_rate * Math.pow(10, -8);

export const toSatsValue = (amount, BTC_rate) =>
  Math.floor(amount * BTC_rate * Math.pow(10, 8));

export const stringToNumber = (value) => Number(value.toString().replace('$', ''));

export default currencyFormat;
